import { createFileRoute, Navigate } from '@tanstack/react-router';
import { pageTitle, usePageTitle } from '@/utils/pageTitle';
import { UserTable } from '@/components/Pages/Users/UserTable';
import { CreateEditUserModal } from '@/components/Pages/Users/CreateEditUserModal';
import { Box } from '@mui/joy';
import { useAuth } from '@/contexts/AuthContext';

export const Route = createFileRoute('/_protected/users/')({
  component: UsersPage,
  head: () => pageTitle('Usuarios'),
});

function UsersPage() {
  usePageTitle('Usuarios');
  const { hasClaim, isLoading, isSuperAdmin } = useAuth();
  const canRead = hasClaim('USERS_READ') || isSuperAdmin;
  const canWrite = hasClaim('USERS_WRITE') || isSuperAdmin;

  if (!isLoading && !canRead) {
    return <Navigate to='/' />;
  }

  return (
    <Box>
      {canWrite && (
        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3, gap: 2 }}
        >
          <CreateEditUserModal />
        </Box>
      )}
      <UserTable />
    </Box>
  );
}
